import React from "react";
import { useState, useEffect, useContext } from "react";
import http from "../../services/http-commons.js";
import NoWishList from "./NoWishList.js";
import { SetAllContext } from "../../services/AllContext.js";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import "./WishList.scss";

const Wishlist = () => {
  const navigate = useNavigate();
  const { userID, setProductSlug } = useContext(SetAllContext);
  // ==================== State =========================
  const [getWishlist, setGetWishlist] = useState([]);

  // =================== Effects =================
  useEffect(() => {
    http.WISHLISTHTTP.get(`/get-wishlists`)
      .then((response) => {
        setGetWishlist(response.data);
      })
      .catch((error) => {
        console.log("ERROR", error);
      });
  }, [userID]);

  //  ============== Functions ================
  function removeWishList(removalId) {
    const deleteWishListItem = http.WISHLISTHTTP.delete(
      `/delete-wishlist/${removalId}`
    );

    toast.promise(
      deleteWishListItem.then(() => {
        // Remove the item from local state
        setGetWishlist((prevWishlist) =>
          prevWishlist.filter((item) => item.id !== removalId)
        );
      }),
      {
        pending: "Removing wishlisted item...",
        success: `Wishlisted item removed! 🎉`,
        error: "Failed to remove wishlisted item 😞",
      },
      {
        autoClose: 3000,
      }
    );
  }

  function formatDate(dateString) {
    if (!dateString) return "";
    const date = new Date(dateString);
    const options = { year: "numeric", month: "long", day: "numeric" };
    const timeOptions = { hour: "2-digit", minute: "2-digit" };

    return `${date.toLocaleDateString(
      undefined,
      options
    )} at ${date.toLocaleTimeString(undefined, timeOptions)}`;
  }

  function openProductItem(orderId) {
    setProductSlug(orderId);
    navigate("/detail/product-details");
  }

  return (
    <div className="wishlist">
      <div className="wishlist-buttons">
        <button
          className="btn btn-primary col-12"
          style={{ marginRight: "3px" }}
        >
          Wishlisted Products
        </button>
      </div>
      {getWishlist.length > 0 ? (
        getWishlist.map((item, index) => (
          <div key={index} className="wishlist-content">
            <div className="wishlist-items">
              <div
                className="col-md-3 wishlist-items-img"
                onClick={() => openProductItem(item?.product?.slug)}
                style={{ cursor: "pointer" }}
              >
                <img
                  src={item?.product?.images || ""}
                  alt={item?.product?.name || ""}
                  style={{
                    width: "100px",
                    height: "100px",
                  }}
                />
              </div>
              <div
                className="col-md-7 wishlist-items-product"
                onClick={() => openProductItem(item?.product?.slug)}
                style={{ cursor: "pointer" }}
              >
                <h6>{item?.product?.name || ""}</h6>
                {item?.product?.inventory_stock > 0 ? (
                  <p>
                    <strong>
                      Amount:{" "}
                      <em>{item?.product?.amount.toLocaleString() || ""}</em>
                    </strong>
                  </p>
                ) : (
                  <p style={{ color: "#FFCCCB", textDecoration: "italics" }}>
                    Out of Stock
                  </p>
                )}
                <p>
                  <strong>Wislisted date:</strong>{" "}
                  <em>{formatDate(item?.created_at)}</em>
                </p>
              </div>
              <div className="col-md-2 d-flex justify-content-center align-items-center">
                <i
                  style={{ color: "#FFCCCB", cursor: "pointer" }}
                  className="fa-solid fa-xmark glow-fontawesome"
                  onClick={() => {
                    removeWishList(item?.id);
                  }}
                ></i>
              </div>
            </div>
          </div>
        ))
      ) : (
        <NoWishList />
      )}
    </div>
  );
};

export default Wishlist;
